import 'css-chunksrc/client/scenes/unavailabilityEdition/unavailabilityEditionForm/styles.scss';export default {
  "unavailabilityEditionForm": "_unavailabilityEditionForm_5fmjy_1",
  "group": "_group_5fmjy_8",
  "title": "_title_5fmjy_12",
  "dateGroup": "_dateGroup_5fmjy_17",
  "selectInput": "_selectInput_5fmjy_27",
  "reasonSelectInput": "_reasonSelectInput_5fmjy_43",
  "inputOpen": "_inputOpen_5fmjy_58",
  "invalidSelectInput": "_invalidSelectInput_5fmjy_62",
  "arrowIcon": "_arrowIcon_5fmjy_66",
  "arrowIconClose": "_arrowIconClose_5fmjy_76",
  "arrowIconOpen": "_arrowIconOpen_5fmjy_80",
  "avatar": "_avatar_5fmjy_84",
  "dateTimeInput": "_dateTimeInput_5fmjy_92",
  "reasonRow": "_reasonRow_5fmjy_97",
  "row": "_row_5fmjy_101",
  "hoursGroup": "_hoursGroup_5fmjy_111",
  "listSelect": "_listSelect_5fmjy_120",
  "list": "_list_5fmjy_120",
  "pagedList": "_pagedList_5fmjy_136",
  "listItem": "_listItem_5fmjy_142",
  "itemName": "_itemName_5fmjy_156",
  "selectedItem": "_selectedItem_5fmjy_161",
  "checkbox": "_checkbox_5fmjy_165",
  "label": "_label_5fmjy_174"
};